import { render, staticRenderFns } from "./PandemicDatabasePerson.vue?vue&type=template&id=0e96d33e&scoped=true&"
import script from "./PandemicDatabasePerson.vue?vue&type=script&lang=js&"
export * from "./PandemicDatabasePerson.vue?vue&type=script&lang=js&"
import style0 from "./PandemicDatabasePerson.vue?vue&type=style&index=0&id=0e96d33e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96d33e",
  null
  
)

export default component.exports